import { useToast } from "vue-toastification/composition";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import router from "@/router";
import axios from "@axios";
import {
  computed,
  reactive,
  toRefs,
  onMounted,
  nextTick,
  ref,
  watch,
} from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { v4 as uuidv4 } from "uuid";
import { fieldStructure } from "@/components/TemplateBuilder/config";

export default function useLayoutConfig() {

  const state = reactive({
    items: [
      {
        name: "",
        type: "facility",
        logic: [],
        errors: {},
        item_id: "facility",
        options: { required: false, app: false, fieldTypeCfg: { data: [] } },
        hasErrors: false,
        isDefault: true,
      },
    ],
    isValid: false,
    templateId: null,
    isUpdating: false,
  });

  const templateName = ref("");
  const tenants = ref([]);

  const user = store.getters["user/getUser"];
  const toast = useToast();
  const { refFormObserver, getValidationState } = formValidation();
  const { t } = useI18nUtils();
  const trans = {
    'maintenance.messages.created_success': t('maintenance.messages.created_success'),
    'maintenance.messages.updated_success': t('maintenance.messages.updated_success'),
  };

  // Computed properties ------------------------------------

  // Watchers ------------------------------------

  // Methods ------------------------------------

  const loadInitData = async () => { };

  const addItem = () => {
    const item = JSON.parse(JSON.stringify(fieldStructure));
    item.item_id = uuidv4();
    state.items.push(item);
  };

  const updateItem = (_item) => { };

  const save = async () => {
    const validation = await refFormObserver.value.validate();

    if (validation) {
      storeTemplate(
        templateName.value,
        state.items
      );
    }
  };

  const storeTemplate = (name, data) => {
    const payload = {
      name,
      data
    };

    if (!state.isUpdating) {
      axios.post("v1/maintenance-templates", { ...payload }).then(({ data }) => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans['maintenance.messages.created_success'],
            icon: "CheckIcon",
            variant: "success",
          },
        });

        state.isUpdating = true;
        state.templateId = data.id;

        router.push({ path: `/maintenance/templates/builder/${state.templateId}` });
      });
    } else {
      axios.put(`v1/maintenance-templates/${state.templateId}`, { ...payload }).then(({ data }) => {
        toast({
          component: ToastificationContent,
          props: {
            title: trans['maintenance.messages.updated_success'],
            icon: "CheckIcon",
            variant: "success",
          },
        });

        state.templateId = data.id;
        router.push({ path: `/maintenance/templates/builder/${state.templateId}` });
      });
    }
  };

  // Hooks ------------------------------------
  onMounted(async () => {

    loadInitData();

    // Load data if current action is updating
    if (router.currentRoute.params.id_template) {
      state.isUpdating = true;
      state.templateId = router.currentRoute.params.id_template;

      const { data } = await axios.get(`v1/maintenance-templates/${state.templateId}`);
      const response = data;

      templateName.value = response.name;
      if (response.data) {
        state.items = response.data;
      }
    }
  });

  return {
    addItem,
    save,
    ...toRefs(state),
    user,
    templateName,
    refFormObserver,
    getValidationState,
    required,
  };
}
